import makeStyles from "@mui/styles/makeStyles";

export const useStyles = makeStyles(() => ({
  list: {
    listStyle: "none",
    margin: 0,
    padding: 0,
  },
}));
